class FaqWidget {
    constructor() {
        const classFaqQuestion = 'faq-card__question';
        const classFaqCardOpened = 'faq-card--opened';
        const classFaqAnswer = 'faq-card__answer';
        const classFaqAnswerText = 'faq-card__answer-text';

        const $faqQuestion = $(`.${classFaqQuestion}`);

        $faqQuestion.on('click', function() {
            const $faqCard = $(this).parent();
            const $answer = $faqCard.find(`.${classFaqAnswer}`);
            const $answerText = $answer.find(`.${classFaqAnswerText}`);
            let textHeight;

            $faqCard.toggleClass(classFaqCardOpened);

            if ($faqCard.hasClass(classFaqCardOpened)) {
                textHeight = $answerText[0].getBoundingClientRect().height + 'px';
            } else {
                textHeight = '0';
            }

            $answer.height(textHeight);
        });
    }
}

window.apps = window.apps || {};
window.apps.FaqWidget = FaqWidget;



// WEBPACK FOOTER //
// ./assets/js/projects/apps/widgets/faq.js